import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { ClipboardList, FileText, FolderKanban, Link, Settings, type LucideIcon } from 'lucide-react';

import { useApp } from '@/presentation/hooks/use-app.js';
import { getVisibleProjectFormTabs, type ProjectFormTabKey } from '@/presentation/pages/projects/project-form/utils/get-visible-tabs.js';

interface Props {
    value: ProjectFormTabKey;
    isEdit: boolean;
    onChange: (value: ProjectFormTabKey) => void;
}

const ICONS: Record<ProjectFormTabKey, LucideIcon> = { dados: FolderKanban, slas: Settings, processos: ClipboardList, documentos: FileText, links: Link };

export function ProjectFormTabs({ value, isEdit, onChange }: Props) {
    const { translate } = useApp();

    const tabs = getVisibleProjectFormTabs(isEdit).map((key) => ({
        key,
        label: translate(`projects.tabs.${key}`),
        icon: ICONS[key]
    }));

    return (
        <Tabs value={value} onChange={(_, v: ProjectFormTabKey) => onChange(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
            {tabs.map((tab) => {
                const Icon = tab.icon;
                return <Tab key={tab.key} value={tab.key} icon={<Icon size={16} />} iconPosition="start" label={tab.label} sx={{ textTransform: 'none', minHeight: 44 }} />;
            })}
        </Tabs>
    );
}
